export const widgetConfig = {
    hotelId: 'canbordoy',
    ticker: 'canbordoy.com',
    engine: 'witbooking',
    showPrice: false,
    defaultAdults: 2,
    defaultChildren: 0,
    currency: 'EUR',
    baseUrl: 'https://reservations.canbordoy.com/',
    urlChain: 'hotel',
    urlHotel: 'hotel',
    showChildAges: false,
    noOnDesktop: true,
    type: 'hotel',
    maxRooms: '5',
    showAllHotelsOption: 'true',
    targetBlank: true,
};
